<ng-container *ngIf="card?.disneyPremierAccess">
    <finder-button
        [href]="card.disneyPremierAccess.href"
        [theme]="card.disneyPremierAccess.theme"
        [fullWidth]="fullWidth"
    >{{card.disneyPremierAccess.label}}</finder-button>
</ng-container>

